import { findKey, inRange, mapValues } from "lodash";

import { ColorScale, ScaleRange } from "./range.helpers.decl";

export function getColorFromRange<T extends string>(colorScale: ColorScale<T>) {
  return (value: number | null) => {
    const formattedColorScale = mapValues(
      colorScale,
      (range) =>
        // Bumps 100 because, inRange is exclusive.
        (range ?? []).map((value) =>
          value === 100 ? 100 + 1 : value
        ) as ScaleRange
    );

    return findKey(formattedColorScale, (range) =>
      inRange(value ?? 0, range?.at(0) ?? -1, range?.at(1))
    ) as T | undefined;
  };
}
